export default __webpack_public_path__ + "static/media/regulatory--stop-signals--g2.7cea9e75.png";